/**
 * 仅 Capacitor iOS 原生：为 html 增加 class，配合 capacitorIosOverscroll.scss 抑制过度滚动。
 * 浏览器 / Android 不执行任何 DOM 修改。
 */
import './capacitorIosOverscroll.scss';

export function initCapacitorIosOverscrollClass() {
  if (typeof window === 'undefined') return;
  const C = window.Capacitor;
  if (!C || typeof C.isNativePlatform !== 'function' || typeof C.getPlatform !== 'function') return;
  try {
    if (C.isNativePlatform() === true && C.getPlatform() === 'ios') {
      document.documentElement.classList.add('wk-ios-native-app');
    }
  } catch (e) {
    /* ignore */
  }
}

/** 仅 Home、Detail 锁整页橡皮筋；其它页保持系统默认滚动/回弹（与全局 isScrollEnabled=false 相反问题的修复） */
const LOCK_BOUNCE_PATHS = ['/home', '/detail'];

export function syncIosLockMainBounceRoute(pathname) {
  if (typeof document === 'undefined') return;
  if (!document.documentElement.classList.contains('wk-ios-native-app')) return;
  const path = pathname || '';
  const lock = LOCK_BOUNCE_PATHS.some(
    p => path === p || path.startsWith(`${p}?`) || path.startsWith(`${p}/`)
  );
  document.documentElement.classList.toggle('wk-ios-lock-main-bounce', lock);
}
